import React from 'react'
import { Button } from 'components/Button'
import { Overlay } from 'components/Overlay'
import { ConfirmSubmissionCancelModal } from '../../views/Modals'

const CancelSubmissionButton = ({ label, type, submission, handleCancel }) =>
	<Overlay
		openByClickOn={
			<Button type={'ghost'} icon={'close'}>
				{label}
			</Button>
		}
	>
		<ConfirmSubmissionCancelModal
			submission={submission}
			handleCancel={handleCancel}
		/>
	</Overlay>

export default CancelSubmissionButton



// WEBPACK FOOTER //
// ./src/containers/Buttons/CancelSubmissionButton.js